import React from "react";
import PropTypes from "prop-types";

const InternalNotesBanner = ({ nonRKPayInvoiceDetailHook }) => {
    const { lang } = global;
    const {
        internalNotes,
        hideInternalNotes,
        toggleInternalNotesModal,
    } = nonRKPayInvoiceDetailHook;

    return (
        <div className="container div-internal-notes">
            <div className="row v-align">
                <div className="col-xs-12 col-sm-2 div-internal-notes-notice">
                    <label
                        className="attention-font"
                        htmlFor="internal-notes"
                    >
                        {lang.t("Internal Notes")}
                    </label>
                    <div className="col-xs-3 col-sm-3 col-md-2 edit-internal-note">
                        <button
                            type="button"
                            className="btn btn-link"
                            onClick={() => toggleInternalNotesModal()}
                        >
                            <i className="rkf rkf-pencil" />
                            &nbsp;{lang.t("Edit")}
                        </button>
                        <button
                            type="button"
                            className="btn btn-link"
                            onClick={() => hideInternalNotes()}
                        >
                            <i
                                className="rkf rkf-cross-circle"
                                aria-label="Close"
                            />
                        </button>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-7 col-md-8 internal-notes-text">
                    {internalNotes}
                </div>
                <div className="col-xs-3 col-sm-3 col-md-2 hidden-xs">
                    <button
                        type="button"
                        className="btn btn-link"
                        onClick={() => toggleInternalNotesModal()}
                    >
                        <i className="rkf rkf-pencil" />
                        &nbsp;{lang.t("Edit")}
                    </button>
                    <button
                        type="button"
                        className="btn btn-link"
                        onClick={() => hideInternalNotes()}
                    >
                        <i
                            className="rkf rkf-cross-circle"
                            aria-label="Close"
                        />
                    </button>
                </div>
            </div>
        </div>
    );
};

InternalNotesBanner.propTypes = {
    nonRKPayInvoiceDetailHook: PropTypes.object.isRequired,
};

export default InternalNotesBanner;
